module.exports = __webpack_public_path__ + "static/collectorcans-slide-img-2-es-MX-00c2e5cdb194ee5461ee4cfcec0e886f.png";